// extracted by mini-css-extract-plugin
module.exports = {"BooksMenu":"BooksMenu_BooksMenu__3AtrY","BooksMenu__MenuDetail":"BooksMenu_BooksMenu__MenuDetail__2m6vY","BooksMenu__Time":"BooksMenu_BooksMenu__Time__32Adj"};